'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var enhancer = function enhancer(actionName) {
  return function (Component) {
    var StopDuplicateAction = function (_React$Component) {
      _inherits(StopDuplicateAction, _React$Component);

      function StopDuplicateAction(props) {
        _classCallCheck(this, StopDuplicateAction);

        var _this = _possibleConstructorReturn(this, (StopDuplicateAction.__proto__ || Object.getPrototypeOf(StopDuplicateAction)).call(this, props));

        _this.doing = false;
        _this.handleAction = _this.handleAction.bind(_this);
        return _this;
      }
      // TODO rewrite with async func and try catch finally


      _createClass(StopDuplicateAction, [{
        key: 'handleAction',
        value: function handleAction() {
          var _this2 = this;

          if (!this.doing) {
            var _props;

            this.doing = true;
            return (_props = this.props)[actionName].apply(_props, arguments).then(function (result) {
              _this2.doing = false;
              return result;
            }).catch(function (error) {
              _this2.doing = false;
              throw error;
            });
          }

          console.debug('stop ' + actionName + '!!');
          return Promise.reject();
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(Component, _extends({}, this.props, _defineProperty({}, actionName, this.handleAction)));
        }
      }]);

      return StopDuplicateAction;
    }(_react2.default.Component);

    StopDuplicateAction.propTypes = _defineProperty({}, actionName, _propTypes.func.isRequired);

    return StopDuplicateAction;
  };
};

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'stopDuplicateAction', true);


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/DocEditor/controlEditor/stopDuplicateAction.js
// module id = 1762
// module chunks = 0